<template>
  <AppointmentScreenWrapper data-qa="appointment_error">
    <template #main>
      <v-img
        contain
        width="130"
        height="130"
        class="mx-auto"
        :src="urls.iconCancel"
        :alt="errorData.title"
      />
      <div
        class="text--text text-h6 mt-4 text-center"
        data-qa="appointment_error_title"
        :style="{ maxWidth: errorData.titleMaxWidth }"
      >
        {{ $t(errorData.title, { ...options, daily_limit: dailyLimit }) }}
      </div>
      <div
        class="text-body-2 text-secondary--text text-center mt-2 mx-auto"
        :style="{ width: isMobile ? '60%' : '' }"
        data-qa="appointment_error_subtitle"
      >
        {{ $t(errorData.subtitle, options) }}
      </div>
      <div
        v-if="!isMobile && errorData.showPhone"
        class="text-h4 text--text text-center mt-4"
      >
        {{ lpuData.phone }}
      </div>
    </template>
    <template
      v-if="isMobile && errorData.showPhone || currentActions.buttonSecond"
      #actions="{ buttonProps }"
    >
      <v-btn
        v-if="isMobile && errorData.showPhone"
        v-bind="buttonProps"
        data-qa="appointment_error_phone_btn"
        :href="`tel:${formattedLpuPhone}`"
      >
        {{ lpuData.phone }}
      </v-btn>
      <template v-else>
        <v-btn
          v-if="currentActions.buttonSecond"
          v-bind="buttonProps"
          :class="{ 'mb-2': currentActions.buttonFirst }"
          data-qa="appointment_error_back_btn"
          v-on="currentActions.buttonSecond.on"
          @click="handleClickButtonSecond"
        >
          {{ $t(currentActions.buttonSecond.text, options) }}
        </v-btn>
        <v-btn
          v-if="currentActions.buttonFirst"
          v-bind="buttonProps"
          text
          data-qa="appointment_error_first_btn"
          v-on="currentActions.buttonFirst.on"
        >
          {{ $t(currentActions.buttonFirst.text, options) }}
        </v-btn>
      </template>
    </template>
  </AppointmentScreenWrapper>
</template>

<script>
import { mapState } from 'pinia'
import { AppointmentPageErrorData } from 'www/vue_components/common/AppointmentPage/mixins'
import AppointmentScreenWrapper from 'www/vue_components/common/AppointmentPage/components/common/AppointmentScreenWrapper.vue'
import { useLpuDataStore, useGlobalDataStore } from 'www/vue_components/common/AppointmentPage/stores'

export default {
  name: 'AppointmentErrorPage',
  components: {
    AppointmentScreenWrapper,
  },
  mixins: [
    AppointmentPageErrorData,
  ],
  props: {
    dailyLimit: {
      type: Number,
      default: 0,
    },
  },
  data: vm => ({
    isMobile: window.MOBILE_VERSION,
    options: { ns: vm.$i18next.language },
  }),
  computed: {
    ...mapState(useGlobalDataStore, [
      'urls',
      'errorData',
    ]),
    ...mapState(useLpuDataStore, [
      'lpuData',
    ]),
    ...mapState(useLpuDataStore, [
      'formattedLpuPhone',
    ]),
  },
}
</script>
